import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesCategoryComponent} from "./sales-category.component";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {BackgroundLinesComponent} from "projects/store/src/app/components/shared/resources/background-lines/background-lines.component";
import {BackgroundCrossesComponent} from "projects/store/src/app/components/shared/resources/background-crosses/background-crosses.component";



@NgModule({
  declarations: [
    SalesCategoryComponent,
    BackgroundLinesComponent,
    BackgroundCrossesComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    PrimengModule,
    GeneralModule
  ],
  exports: [
    SalesCategoryComponent,
  ]
})
export class SalesCategoryModule { }
